import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#141329",
    padding: "48px 0",
    [theme.breakpoints.down("md")]: {
      padding: "30px 0",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "1366px",
    [theme.breakpoints.down("md")]: {
      padding: "0 24px",
    },
  },
  title: {
    fontSize: 48,
    fontWeight: 900,
    color: "#fff",
    lineHeight: "48px",
    textAlign: "center",
    letterSpacing: 0,
    marginBottom: 16,
    [theme.breakpoints.down("md")]: {
      fontSize: 32,
      lineHeight: "40px",
      marginBottom: 6,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 30,
      fontWeight: 800,
      lineHeight: "36px",
    },
  },
  // The plain title was a <span>; as an <h2> it must not pick up the browser's heading margin.
  titleHeading: {
    marginTop: 0,
  },
  limitedBogoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 58,
    [theme.breakpoints.down("md")]: {
      marginBottom: 22,
    },
  },
  limitedBogoButton: {
    background: "#DC2626",
    borderRadius: 8,
    padding: "14px 28px",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
    "& > span": {
      fontSize: 20,
      fontWeight: 800,
      color: "#fff",
      letterSpacing: "0.3px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 20,
      padding: "14px 18px",
      "& > span": {
        fontSize: 16,
      },
    },
  },
  countdownIcon: {
    width: 20,
    height: 20,
    objectFit: "contain",
    marginRight: 12,
  },
  tncApply: {
    fontSize: 20,
    lineHeight: "30px",
    color: "#d1d5db",
    fontWeight: 500,
    textDecoration: "none",
    display: "none",
    "& a": {
      color: "#d1d5db !important",
      fontWeight: "500 !important",
      textDecoration: "none !important",
    },
    "& a:hover": {
      color: "#d1d5db !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      lineHeight: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  plansContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "center",
    gap: "24px",
    width: "100%",
    maxWidth: 1184,
    marginBottom: 0,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: 0,
      maxWidth: 312,
      marginBottom: 0,
      padding: "0 !important",
    },
  },
  figmaPlanCardAnchor: {
    width: "auto !important",
    maxWidth: "none",
    minWidth: "378.67px",
    flex: "1 1 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textDecorationLine: "none",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
      maxWidth: 312,
      flex: "0 0 auto",
      height: "203px !important",
      "& > div": {
        height: "203px !important",
        marginBottom: "0 !important",
      },
    },
  },
  figmaPlanRoot: {
    borderRadius: "24px !important",
    border: "4px solid #403de3 !important",
    boxShadow: "none !important",
    background: "#403de3 !important",
    overflow: "hidden",
    minHeight: "323px",
    [theme.breakpoints.down("md")]: {
      borderRadius: "12px !important",
      borderWidth: "0 !important",
      height: "203px !important",
      minHeight: "203px",
      background: "transparent !important",
      overflow: "visible",
      "& > div:nth-child(2)": {
        height: "163px !important",
        marginTop: "16px !important",
        background: "transparent !important",
      },
    },
    "& > div:nth-child(2)": {
      border: "none !important",
      background: "#403de3 !important",
    },
    "& span": {
      letterSpacing: "0 !important",
    },
  },
  figmaPlanBadge: {
    minHeight: 52,
    height: "52px !important",
    padding: "13px 32px !important",
    backgroundColor: "#403de3 !important",
    borderRadius: "0 !important",
    boxSizing: "border-box",
    "& > span": {
      color: "#fff !important",
      fontSize: "20px !important",
      lineHeight: "26px !important",
      fontWeight: "700 !important",
      textTransform: "uppercase !important",
    },
    "& > #activeText": {
      color: "#fff !important",
      marginLeft: "4px !important",
    },
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: "0 !important",
      left: "50%",
      zIndex: 2,
      transform: "translateX(-50%)",
      minHeight: 29,
      width: "auto !important",
      height: "29px !important",
      padding: "4px 20px !important",
      borderRadius: "24px !important",
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      "& > span": {
        fontSize: "14px !important",
        lineHeight: "21px !important",
        fontWeight: "800 !important",
        whiteSpace: "nowrap",
      },
    },
  },
  figmaPlanContent: {
    height: "278px !important",
    minHeight: "278px !important",
    padding: "35px 32px 30px !important",
    borderRadius: "0 0 12px 12px !important",
    background: "#fff !important",
    gap: "0 !important",
    justifyContent: "flex-start !important",
    boxSizing: "border-box",
    "& > span:first-child": {
      order: 1,
      fontSize: "24px !important",
      lineHeight: "24px !important",
      fontWeight: "800 !important",
      color: "#000 !important",
      textAlign: "center !important",
      marginBottom: "14px !important",
      width: "100%",
    },
    "& > span": {
      textAlign: "center !important",
      width: "100%",
    },
    "& > span:nth-of-type(2)": {
      order: 4,
      marginTop: "4px !important",
      marginBottom: "0 !important",
      lineHeight: "16px !important",
    },
    "& > span:nth-of-type(2) > span:first-child": {
      color: "#DC2626 !important",
      fontSize: "16px !important",
      lineHeight: "16px !important",
      fontWeight: "700 !important",
      textDecoration: "line-through !important",
    },
    "& > span:nth-of-type(2) > span:last-child": {
      color: "#000 !important",
      fontSize: "16px !important",
      lineHeight: "16px !important",
      fontWeight: "800 !important",
      textDecoration: "none !important",
    },
    "& > span:nth-of-type(3)": {
      order: 3,
      color: "#3b51fc !important",
      fontSize: "16px !important",
      lineHeight: "30px !important",
      fontWeight: "700 !important",
      marginTop: "11px !important",
      marginBottom: "0 !important",
      width: "100% !important",
      maxWidth: "100%",
      alignSelf: "center",
      whiteSpace: "nowrap",
    },
    "& > span:nth-of-type(3) > span:first-child": {
      color: "#403de3 !important",
      fontSize: "30px !important",
      lineHeight: "45px !important",
      fontWeight: "800 !important",
    },
    "& > span:nth-of-type(3) > span:last-child": {
      color: "#403de3 !important",
      fontSize: "16px !important",
      lineHeight: "24px !important",
      fontWeight: "700 !important",
    },
    [theme.breakpoints.down("md")]: {
      height: "163px !important",
      minHeight: "163px !important",
      position: "relative",
      display: "block !important",
      padding: "0 !important",
      borderRadius: "12px !important",
      "& > span:first-child": {
        position: "absolute",
        top: "32px",
        left: "16px",
        width: "148px !important",
        fontSize: "16px !important",
        lineHeight: "21px !important",
        marginBottom: "0 !important",
        textAlign: "left !important",
        whiteSpace: "normal",
      },
      "& > span:nth-of-type(2)": {
        position: "absolute",
        top: "78px",
        left: "16px",
        width: "148px !important",
        marginTop: "0 !important",
        lineHeight: "18px !important",
        textAlign: "left !important",
      },
      "& > span:nth-of-type(2) > span:first-child": {
        fontSize: "12px !important",
        lineHeight: "18px !important",
      },
      "& > span:nth-of-type(2) > span:last-child": {
        fontSize: "12px !important",
        lineHeight: "18px !important",
      },
      "& > span:nth-of-type(3)": {
        position: "absolute",
        top: "53px",
        right: "16px",
        fontSize: "12px !important",
        lineHeight: "18px !important",
        marginTop: "0 !important",
        width: "112px !important",
        whiteSpace: "normal",
        textAlign: "right !important",
      },
      "& > span:nth-of-type(3) > span:first-child": {
        display: "block",
        fontSize: "18px !important",
        lineHeight: "27px !important",
        fontWeight: "800 !important",
        textAlign: "center !important",
      },
      "& > span:nth-of-type(3) > span:last-child": {
        fontSize: "12px !important",
        lineHeight: "18px !important",
        fontWeight: "600 !important",
        color: "#000 !important",
        textAlign: "right !important",
      },
    },
  },
  figmaPlanButtonWrap: {
    order: 5,
    position: "static !important",
    marginTop: "6px !important",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      position: "absolute !important",
      top: "114px",
      left: 0,
      marginTop: "0 !important",
      display: "flex",
      justifyContent: "center",
    },
    "& > button": {
      minWidth: "160px !important",
      height: "29px !important",
      padding: "4px 20px !important",
      borderRadius: "24px !important",
      background: "#403de3 !important",
      boxShadow: "none !important",
      "& > span": {
        color: "#fff !important",
        fontSize: "14px !important",
        lineHeight: "21px !important",
        fontWeight: "800 !important",
      },
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "20px !important",
      display: "flex",
      justifyContent: "center",
      "& > button": {
        height: "41px !important",
        minWidth: "222px !important",
        borderRadius: "999px !important",
        background: "#403de3 !important",
        "& > span": {
          fontSize: "16px !important",
          lineHeight: "21px !important",
          fontWeight: "800 !important",
        },
        "& span": {
          fontSize: "16px !important",
          lineHeight: "21px !important",
          fontWeight: "800 !important",
        },
        "& .MuiButton-label": {
          fontSize: "16px !important",
          lineHeight: "21px !important",
          fontWeight: "800 !important",
        },
      },
    },
  },
  // Trello 596 "27 OCT 2": empty-plan notice, same column width as the
  // mobile plan cards, 24px above the guarantee block.
  unavailableNoticeWrap: {
    width: "100%",
    maxWidth: 480,
    margin: "0 auto 24px",
  },
  mobilePlansContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 312,
    margin: "0 auto",
  },
  mobilePlanCard: {
    position: "relative",
    width: 312,
    height: 203,
    padding: 0,
    margin: 0,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontFamily: 'Muli, "Open Sans", sans-serif',
    textAlign: "left",
    display: "block",
    "&:focus": {
      outline: "none",
    },
  },
  mobilePlanSaveBadge: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    minHeight: 29,
    maxWidth: 260,

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 24,
    background: "#403de3",
    color: "#fff",
    fontSize: 14,
    lineHeight: "21px",
    fontWeight: 800,
    textAlign: "center",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    zIndex: 2,
    boxSizing: "border-box",
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.down("sm")]: {
      minHeight: 32,
    },
  },
  mobilePlanBody: {
    width: 312,
    height: 163,
    borderRadius: 12,
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    overflow: "hidden",
    padding: "24px 16px 20px",
    boxSizing: "border-box",
    // marginTop: "-16px",
  },
  mobilePlanInfoRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
  },
  mobilePlanLeftColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: 148,
  },
  mobilePlanTitle: {
    width: 148,
    color: "#000",
    fontSize: 16,
    lineHeight: "21px",
    fontWeight: 800,
    textAlign: "left",
    whiteSpace: "normal",
  },
  mobilePlanPromoText: {
    width: 112,
    minHeight: 21,
    padding: 0,
    borderRadius: 0,
    background: "transparent",
    color: "#047857",
    fontSize: 14,
    lineHeight: "21px",
    fontWeight: 800,
    textAlign: "right",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
  },
  mobilePlanMonthly: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    width: 112,
    textAlign: "right",
  },
  mobilePlanAmount: {
    display: "block",
    color: "#3b51fb",
    fontSize: 18,
    lineHeight: "27px",
    fontWeight: 900,
    textAlign: "right",
  },
  mobilePlanSuffix: {
    display: "block",
    color: "#000",
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 700,
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  mobilePlanPriceRow: {
    width: 148,
    display: "flex",
    alignItems: "center",
    marginTop: 4,
    whiteSpace: "nowrap",
  },
  mobilePlanOriginalPrice: {
    color: "#DC2626",
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 700,
    textDecoration: "line-through",
  },
  mobilePlanCurrentPrice: {
    color: "#000",
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 800,
    marginLeft: 4,
  },
  mobilePlanCta: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 160,
    height: 29,
    // padding: "4px 20px",
    borderRadius: 24,
    background: "#403de3",
    color: "#fff",
    fontSize: 14,
    lineHeight: "21px",
    fontWeight: 800,
    textAlign: "center",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      height: 36,
    },
  },
  planProductNotes: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 1184,
    marginTop: 24,
    "& > span": {
      display: "none",
    },
    "& > :first-child": {
      display: "block",
      color: "#2E8AFD",
      fontSize: 18,
      lineHeight: "26px",
      fontWeight: 600,
      textDecoration: "underline",
      textAlign: "center",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      maxWidth: 312,
      marginTop: 0,
      gap: 0,
      "& > span": {
        display: "none",
        color: "#d1d5db",
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: 500,
        textAlign: "center",
      },
      "& > :first-child": {
        display: "block",
        color: "#2E8AFD",
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: 600,
        textDecoration: "underline",
      },
    },
  },
  planSpecNote: {
    background: "#f2f3ff",
    borderRadius: 12,
    padding: "14px 24px",
    color: "#403de3 !important",
    fontWeight: "800 !important",
    width: "100%",
    boxSizing: "border-box",
  },
  // Trello 467 — payment-mitigation store-link cards on /plan and /flashdeals
  // (same mockup as get-plan final-summary: Figma 3ccS24jZ9QqpxcZj7dkY1E).
  // Footnote uses the light landing text colour — this section sits on the
  // dark #141329 background.
  ctnStoreOptions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    maxWidth: 440,
    margin: "0 auto",
    // JSS drops unitless `gap` in the production build — keep the px unit.
    gap: "16px",
  },
  storeOptionCard: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    background: "#fff",
    border: "1px solid #ebebeb",
    borderRadius: 16,
    padding: "18px 24px",
    textDecoration: "none",
    boxSizing: "border-box",
    boxShadow: "0 2px 4px -2px rgba(0, 0, 0, 0.10), 0 8px 16px -1px rgba(0, 0, 0, 0.20)",
    [theme.breakpoints.down("sm")]: {
      padding: "16px 20px",
    },
  },
  storeOptionLabel: {
    fontSize: 16,
    fontWeight: 800,
    lineHeight: 1.25,
    color: "#231f20",
    maxWidth: 90,
    whiteSpace: "pre-line",
  },
  storeOptionBadge: {
    height: 40,
    width: "auto",
    objectFit: "contain",
    marginLeft: "auto",
  },
  storeOptionChevron: {
    color: "#231f20",
    marginLeft: 8,
    flexShrink: 0,
  },
  planCard: {
    flex: 1,
    maxWidth: 360,
    background: "#403DE3",
    borderRadius: 12,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    border: "3px solid #403DE3",
  },
  planHeader: {
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > span": {
      fontSize: 16,
      fontWeight: 800,
      color: "#fff",
      textAlign: "center",
      letterSpacing: "0.5px",
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
      },
    },
  },
  saveText: {
    fontSize: 20,
    fontWeight: 800,
    color: "#fff",
  },
  planBody: {
    padding: "20px 24px",
    background: "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    flex: 1,
    [theme.breakpoints.down("md")]: {
      padding: "24px 20px",
      gap: 16,
    },
  },
  duration: {
    fontSize: 24,
    fontWeight: 800,
    color: "#000",
    textAlign: "center",
  },
  promoLabel: {
    background: "#10B981",
    borderRadius: 6,
    padding: "6px 14px",
    display: "inline-block",
    width: "fit-content",
    "& > span": {
      fontSize: 13,
      fontWeight: 700,
      color: "#fff",
      letterSpacing: "0.3px",
    },
  },
  priceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    marginTop: 4,
  },
  originalPrice: {
    fontSize: 15,
    color: "#E53E3E",
    textDecoration: "line-through",
    fontWeight: 600,
    lineHeight: "20px",
  },
  discountedPrice: {
    fontSize: 36,
    fontWeight: 900,
    color: "#000",
    lineHeight: "42px",
    [theme.breakpoints.down("md")]: {
      fontSize: 32,
      lineHeight: "38px",
    },
  },
  perMonth: {
    fontSize: 13,
    color: "#666",
    fontWeight: 500,
    lineHeight: "18px",
    marginTop: 2,
  },
  planButton: {
    marginTop: "auto",
    "& > button": {
      width: "100%",
    },
  },
  productInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 64,
    "& > span": {
      fontSize: 14,
      color: "#fff",
      textAlign: "center",
      opacity: 0.85,
      lineHeight: "20px",
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: 48,
    },
    "& > span:first-child": {
      fontSize: 16,
      fontWeight: 800,
      color: "#fff",
      textAlign: "center",
    },
  },
  guaranteeSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: 900,
    padding: "0 24px",
    marginTop: 64,
    [theme.breakpoints.down("md")]: {
      marginTop: 60,
    },
  },
  flashGuarantee: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: 900,
    marginLeft: "auto",
    marginRight: "auto",
    padding: "0 24px",
    marginTop: 80,
    [theme.breakpoints.down("sm")]: {
      marginTop: 48,
    },
    // Figma 15330:153 spec overrides for flashdeals guarantee section.
    // DT: icon 150x150, title 48px fw=900 white, supporting 20px fw=500 #3B51FB.
    // MB: icon 100x100, title 30px fw=800 white, supporting 16px fw=500 #3B51FB.
    "& $guaranteeBadge": {
      width: 150,
      height: 150,
      [theme.breakpoints.down("sm")]: {
        width: 100,
        height: 100,
      },
    },
    "& $guaranteeTitle": {
      fontSize: 48,
      fontWeight: 900,
      lineHeight: "48px",
      color: "#fff",
      [theme.breakpoints.down("sm")]: {
        fontSize: 30,
        fontWeight: 800,
        lineHeight: "34px",
      },
    },
    "& $guaranteeDescription": {
      fontSize: 20,
      fontWeight: 500,
      lineHeight: "30px",
      color: "#3B51FB",
      marginBottom: 0,
      [theme.breakpoints.down("sm")]: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: "24px",
      },
      "& a": {
        color: "#3B51FB",
        fontWeight: 500,
        textDecoration: "none",
        "&:hover": {
          color: "#3B51FB",
        },
      },
    },
  },
  guaranteeBadge: {
    width: 140,
    height: 140,
    objectFit: "contain",
    marginBottom: 28,
    [theme.breakpoints.down("md")]: {
      width: 120,
      height: 120,
      marginBottom: 16,
    },
  },
  guaranteeTitle: {
    fontSize: 36,
    fontWeight: 800,
    color: "#fff",
    lineHeight: "44px",
    letterSpacing: "-0.5px",
    marginBottom: 12,
    [theme.breakpoints.down("md")]: {
      fontSize: 30,
      lineHeight: "36px",
      marginBottom: 6,
    },
  },
  starTitle: {
    fontSize: 30,
    fontWeight: 800,
    color: "#fff",
    lineHeight: "20px",
    marginLeft: 4,
    [theme.breakpoints.down("md")]: {
      fontSize: 24,
    },
  },
  guaranteeContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    cursor: "pointer",
  },
  guaranteeDescription: {
    fontSize: 16,
    color: "#fff",
    lineHeight: "26px",
    marginBottom: 20,
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
    },
  },
  termsText: {
    fontSize: 16,
    color: "#fff",
    opacity: 0.85,
    lineHeight: "20px",
    [theme.breakpoints.up("md")]: {
      fontSize: 18,
    },
  },
  link: {
    color: "#2E8AFD",
    fontWeight: 600,
    textDecoration: "underline",
    "&:hover": {
      color: "#5A4CFD",
    },
  },
  ctnSpec: {
    flexDirection: "column",
    backgroundColor: "#F2F3FF",
    // marginTop: 30,
    marginTop: 16,
    padding: "12px 20px",
    borderRadius: 12,
    display: "flex",
    justifyContent: "center",
    aligItems: "center",
    "& > span": {
      fontWeight: 900,
      color: "#403DE3",
      fontSize: 16,
      textAlign: "center",
    },
  },
  ctnPromoStyle: {
    order: 2,
    backgroundColor: "#CEF1E2",
    color: "#047857",
    borderRadius: 12,
    padding: "4px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 0,
    marginBottom: 0,
    [theme.breakpoints.up("sm")]: {
      border: "1px solid #0E9F6E",
    },
    "& > span": {
      fontSize: "16px !important",
      lineHeight: "24px !important",
      fontWeight: "900 !important",
      color: "#047857 !important",
      marginBottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto !important",
      position: "absolute",
      top: "32px",
      right: "16px",
      padding: 0,
      height: "21px !important",
      background: "transparent",
      marginTop: "0 !important",
      "& > span": {
        fontSize: "14px !important",
        lineHeight: "21px !important",
        fontWeight: "700 !important",
      },
    },
  },
  btnStylePlanPriceMobile: {
    background: "#403DE3 !important",
    "& > span": {
      color: "#fff !important",
    },
  },
  ctnMainContentStyle: {
    minHeight: "242px !important",
  },
  btnAbsoluteStyle: {
    bottom: "34px",
    "& > button > span": {
      fontSize: "18px !important",
    },
  },
  bottomInnerStyle: {
    [theme.breakpoints.up("sm")]: {
      "& > span": {
        fontSize: "20px !important",
      },
    },
  },
  ctnPlanPricingContent: {
    marginBottom: "0px !important",
  },
  ctnPlanPricingContentRoot: {
    boxShadow:
      "0px 10px 20px -4px rgba(88, 80, 236, 0.7), 0px 4px 12px rgba(88, 80, 236, 0.6)",
    border: "none",
  },
  flashRoot: {
    background: "#000",
    padding: "42px 0 54px",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 0 30px",
    },
  },
  flashContainer: {
    maxWidth: 1232,
    padding: "0",
    [theme.breakpoints.down("md")]: {
      padding: "0 36px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 30px",
    },
  },
  flashTitle: {
    letterSpacing: 0,
    marginBottom: 22,
    fontSize: 48,
    fontWeight: 800,
    lineHeight: "72px",
    [theme.breakpoints.down("md")]: {
      fontSize: 44,
      lineHeight: "54px",
      maxWidth: 780,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 38,
      lineHeight: "44px",
      maxWidth: 390,
      marginBottom: 26,
    },
    [theme.breakpoints.down(380)]: {
      fontSize: 34,
      lineHeight: "40px",
    },
  },
  flashCountdown: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    minHeight: 42,
    padding: "8px 18px",
    marginBottom: 18,
    borderRadius: 999,
    background: "#17171c",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    "& > span": {
      color: "#fff",
      fontSize: 15,
      fontWeight: 700,
      letterSpacing: 0,
    },
    "& > strong": {
      color: "#fff",
      fontSize: 18,
      fontWeight: 900,
      letterSpacing: 0,
      fontVariantNumeric: "tabular-nums",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 16,
      padding: "8px 14px",
      "& > span": {
        fontSize: 13,
      },
      "& > strong": {
        fontSize: 16,
      },
    },
  },
  flashCountdownIcon: {
    width: 18,
    height: 18,
    objectFit: "contain",
  },
  flashTabs: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    width: "100%",
    maxWidth: 522,
    minHeight: 60,
    overflow: "hidden",
    borderRadius: 12,
    background: "#27272a",
    marginBottom: 58,
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      maxWidth: 312,
      minHeight: 92,
      height: 92,
      borderRadius: 12,
      marginBottom: 60,
      overflow: "hidden",
      "& > button:first-child": {
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      "& > button:last-child": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
      },
    },
  },
  // Trello 527 — three duration tabs (international 6-month) share the row
  // evenly; the default flashTabs is a fixed 2-up grid / 50%-width flex row.
  flashTabsThreeUp: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    maxWidth: 720,
    [theme.breakpoints.down("sm")]: {
      maxWidth: 312,
      "& > button": {
        flex: "0 0 33.333%",
        width: "33.333%",
      },
    },
  },
  flashTab: {
    border: "none",
    cursor: "pointer",
    background: "#292a2f",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
    padding: "16px",
    fontSize: 15,
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: 0,
    fontFamily: "inherit",
    minWidth: 0,
    "&:focus": {
      outline: "none",
    },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      flexDirection: "column",
      gap: 0,
      alignItems: "center",
      flex: "0 0 50%",
      width: "50%",
      height: 92,
      padding: "8px 12px",
      fontSize: 14,
      lineHeight: "21px",
      borderRadius: 0,
      boxSizing: "border-box",
      overflow: "hidden",
    },
    [theme.breakpoints.down(380)]: {
      fontSize: 16,
    },
  },
  flashTabActive: {
    background: "#403DE3",
    fontWeight: 800,
  },
  flashTabWithBadge: {},
  flashTabDesktopLabel: {
    display: "inline",
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  flashTabMobileLabel: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "inline",
      whiteSpace: "normal",
      overflowWrap: "normal",
      flex: "0 0 auto",
      maxWidth: "100%",
      textAlign: "center",
    },
  },
  flashTabBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    marginLeft: 8,
    minWidth: 94,
    minHeight: 25,
    padding: "2px 12px",
    borderRadius: 12,
    background: "#DC2626",
    color: "#fff",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "21px",
    whiteSpace: "nowrap",
    letterSpacing: 0,
    [theme.breakpoints.down("sm")]: {
      position: "static",
      minWidth: 84,
      minHeight: 22,
      padding: "2px 12px",
      marginLeft: 0,
      marginTop: 4,
      fontSize: 12,
      lineHeight: "18px",
    },
    [theme.breakpoints.down(380)]: {
      fontSize: 14,
      padding: "5px 10px",
    },
  },
  flashCards: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(2, 380px)",
    columnGap: 24,
    gridColumnGap: 24,
    justifyContent: "center",
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "minmax(0, 312px)",
      width: "100%",
      maxWidth: 312,
      margin: "0 auto",
      justifyContent: "stretch",
      columnGap: 0,
      gridColumnGap: 0,
      rowGap: 48,
      gridRowGap: 48,
    },
  },
  flashCard: {
    position: "relative",
    minWidth: 0,
  },
  flashSaveBadge: {
    position: "absolute",
    top: -22,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2,
    minHeight: 42,
    minWidth: 138,
    padding: "9px 22px",
    borderRadius: 999,
    background: "#3654f6",
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: 900,
    lineHeight: "22px",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      top: -20,
      minHeight: 40,
      minWidth: 132,
      fontSize: 18,
      lineHeight: "22px",
    },
  },
  flashCardInner: {
    minHeight: 517,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: 24,
    padding: "42px 32px 32px",
    boxShadow:
      "0 2px 4px -2px rgba(0, 0, 0, 0.05), 0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("md")]: {
      minHeight: 517,
      padding: "42px 32px 32px",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 420,
      padding: "32px",
      border: "1px solid #E5E7EB",
      borderRadius: 24,
      boxShadow:
        "0 2px 4px -2px rgba(0, 0, 0, 0.05), 0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    },
    [theme.breakpoints.down(380)]: {
      padding: "24px",
    },
  },
  flashCardTitle: {
    margin: 0,
    color: "#3555f4",
    fontSize: 18,
    fontWeight: 800,
    lineHeight: "27px",
    letterSpacing: 0,
    minHeight: 27,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      lineHeight: "24px",
      minHeight: 48,
    },
  },
  flashCardTitleDesktop: {
    display: "inline",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  flashCardTitleMobile: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "inline",
    },
  },
  flashOriginalPrice: {
    display: "block",
    marginTop: 12,
    color: "#fb565a",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "24px",
    letterSpacing: 0,
    textDecoration: "line-through",
    [theme.breakpoints.down("sm")]: {
      marginTop: 4,
      fontSize: 14,
      lineHeight: "21px",
    },
  },
  flashPriceRow: {
    display: "flex",
    alignItems: "baseline",
    gap: 10,
    marginTop: 8,
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      gap: 4,
      marginTop: 8,
    },
    [theme.breakpoints.down(380)]: {
      flexWrap: "wrap",
      rowGap: 4,
    },
  },
  flashMainPrice: {
    minWidth: 0,
    color: "#101827",
    fontSize: 36,
    fontWeight: 800,
    lineHeight: "36px",
    letterSpacing: 0,
    overflowWrap: "anywhere",
    [theme.breakpoints.down("md")]: {
      fontSize: 36,
      lineHeight: "36px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      lineHeight: "34px",
    },
    [theme.breakpoints.down(380)]: {
      fontSize: 30,
      lineHeight: "38px",
    },
  },
  flashPeriodText: {
    color: "#6b7280",
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "24px",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
      lineHeight: "22.5px",
    },
  },
  flashFeatureList: {
    listStyle: "none",
    padding: 0,
    margin: "24px 0",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    [theme.breakpoints.down("sm")]: {
      margin: "24px 0",
    },
  },
  flashFeatureItem: {
    display: "flex",
    alignItems: "center",
    color: "#6f7786",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: 0,
    marginBottom: 8,
    "&:last-child": {
      marginBottom: 0,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      lineHeight: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
      lineHeight: "19.5px",
    },
    [theme.breakpoints.down(380)]: {
      fontSize: 16,
      lineHeight: "23px",
    },
  },
  flashCheckIcon: {
    width: 16,
    height: 16,
    flex: "0 0 16px",
    marginRight: 12,
    backgroundColor: "#3B51FB",
    maskImage:
      "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z' fill='%23000'/%3E%3C/svg%3E\")",
    maskRepeat: "no-repeat",
    maskSize: "16px 16px",
    maskPosition: "center",
    WebkitMaskImage:
      "url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.8455 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9656 6.9656L7.7656 10.1656C7.61558 10.3156 7.41213 10.3998 7.2 10.3998C6.98787 10.3998 6.78442 10.3156 6.6344 10.1656L5.0344 8.5656C4.88868 8.41472 4.80804 8.21263 4.80986 8.00288C4.81169 7.79312 4.89582 7.59247 5.04415 7.44414C5.19247 7.29582 5.39312 7.21168 5.60288 7.20986C5.81264 7.20804 6.01472 7.28867 6.1656 7.4344L7.2 8.4688L9.8344 5.8344C9.98528 5.68867 10.1874 5.60804 10.3971 5.60986C10.6069 5.61168 10.8075 5.69582 10.9559 5.84414C11.1042 5.99247 11.1883 6.19312 11.1901 6.40288C11.192 6.61263 11.1113 6.81472 10.9656 6.9656Z' fill='%23000'/%3E%3C/svg%3E\")",
    WebkitMaskRepeat: "no-repeat",
    WebkitMaskSize: "16px 16px",
    WebkitMaskPosition: "center",
    [theme.breakpoints.down("sm")]: {
      width: 16,
      height: 16,
      flexBasis: 16,
      maskSize: "16px 16px",
      WebkitMaskSize: "16px 16px",
    },
  },
  flashCta: {
    width: "100%",
    minHeight: 44,
    marginTop: "auto",
    border: "none",
    borderRadius: 999,
    background: "#3d52f5",
    color: "#fff",
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: 16,
    fontWeight: 800,
    lineHeight: "24px",
    letterSpacing: 0,
    textAlign: "center",
    padding: "10px 20px",
    [theme.breakpoints.down("sm")]: {
      minHeight: 41,
      fontSize: 14,
      lineHeight: "21px",
      padding: "10px 20px",
    },
    "&:focus": {
      outline: "none",
    },
  },
  flashCtaLite: {
    background: "#c9cdfd",
    color: "#101827",
  },
  styleSubPriceText: {
    [theme.breakpoints.down(400)]: {
      fontSize: "13px !important",
    },
  },
}));

export default useStyles;
